import { Component, OnInit } from '@angular/core';
import Utils from 'src/app/helpers/utils';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { ApiService } from 'src/app/services/api/api.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { MaskPipe } from 'ngx-mask';
import {
  BreadcrumbService,
  BreadcrumbItem,
} from 'src/app/services/breadcrumb/breadcrumb.service';

type PermissionProps = {
  label: string;
  value: number;
};

type PermissionResponse = {
  description: string;
  id: number;
  slug: string;
  type: string;
};

@Component({
  selector: 'app-dashboard-companies-resume',
  templateUrl: './dashboard-companies-resume.component.html',
  styleUrls: ['./dashboard-companies-resume.component.scss'],
})
export class DashboardCompaniesResumeComponent implements OnInit {
  sendingRequest: boolean = false;

  data: CompanyBondValues;
  user: NewLoginResponse | undefined;

  constructor(
    public route: Router,
    public formBuilder: FormBuilder,
    private authService: AuthService,
    private router: ActivatedRoute,
    private toast: ToastService,
    private api: ApiService,
    private storageService: StorageService,
    private maskPipe: MaskPipe,
    private breadcrumbService: BreadcrumbService
  ) {}

  ngOnInit(): void {
    if (
      !this.authService.verifyPermission(['de_can_add_group_permission']) &&
      !this.authService.verifyPermission(['de_can_change_group_permission'])
    ) {
      this.toast.show(
        'error',
        'Aviso',
        'Você não tem permissão para acessar essa página.'
      );
      this.route.navigateByUrl('/app/dashboard');
    }

    this.data = this.storageService.get('companyBondValues');
    this.user = this.authService.getUser();

    this.setBreadcrumb();

    if (!this.data) {
      this.toast.show(
        'error',
        'Erro',
        'Por favor, selecione os vínculos desejados.'
      );
      this.route.navigateByUrl(
        `app/permissions/companies/${this.router.snapshot.params.id}/bond`
      );
    }
  }

  async handleAdd() {
    this.sendingRequest = true;
    try {
      const payload = {
        profiles: this.data.profiles.map((profile) => profile.value),
      };

      await this.api.put({
        route: `api/v2/group/${this.data.id}/`,
        body: payload,
        token: true,
      });

      this.storageService.remove('bond');
      this.toast.show('info', 'Sucesso', 'Vínculo adicionado com sucesso.');

      const groupId = this.router.snapshot.params.groupId;
      const companyId = this.router.snapshot.params.id;

      this.route.navigateByUrl(
        !groupId
          ? `app/permissions/companies/details/${companyId}`
          : `app/permissions/companies/${companyId}/group/details/${groupId}`
      );
    } catch (error) {
      this.toast.show(
        'error',
        'Erro',
        'Ocorreu um erro ao adicionar o vínculo.'
      );
    }

    this.sendingRequest = false;
  }

  handleCancel() {
    this.storageService.remove('bond');

    const groupId = this.router.snapshot.params.groupId;
    const companyId = this.router.snapshot.params.id;

    this.route.navigateByUrl(
      !groupId
        ? `app/permissions/companies/details/${companyId}`
        : `app/permissions/companies/${companyId}/group/details/${groupId}`
    );
  }

  formatDocument(document: string) {
    const newValue = Utils.formatDocumentForDisplay(document);

    return newValue.replace(/\D/g, '');
  }

  setBreadcrumb(): void {
    const canViewCompanies = this.authService.verifyPermission(
      'de_can_view_companies'
    );
    const companyId = this.router.snapshot.params.id;
    const groupId = this.router.snapshot.params.groupId;
    const breadcrumbs: BreadcrumbItem[] = [
      {
        label: 'Empresas',
        url: '/app/permissions/companies',
        clickable: canViewCompanies,
      },
      {
        label: 'Detalhes da empresa',
        url: `/app/permissions/companies/details/${companyId}`,
        clickable: canViewCompanies,
      },
    ];

    if (groupId) {
      breadcrumbs.push({
        label: 'Detalhes do grupo',
        url: `/app/permissions/companies/${companyId}/group/details/${groupId}`,
        clickable: canViewCompanies,
      });
    }

    breadcrumbs.push({
      label: 'Vincular perfis de usuário',
      url: groupId
        ? `/app/permissions/companies/${companyId}/bond/group/${groupId}`
        : `/app/permissions/companies/${companyId}/bond`,
      clickable: canViewCompanies,
    });

    breadcrumbs.push({
      label: 'Resumo',
      url: this.route.url,
      clickable: false, // Página atual, não precisa ser clicável
    });

    this.breadcrumbService.setBreadcrumbs(breadcrumbs);
  }
}
